// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes circular-animation-dca854cc{to{stroke-dashoffset:0}}.image-component[data-v-dca854cc]{margin:0 auto;overflow:hidden;width:100%}.image-component .image[data-v-dca854cc]{width:100%}.image-component .image .image-wrapper[data-v-dca854cc]{aspect-ratio:1;width:100%}.image-component .image .image-wrapper img[data-v-dca854cc]{height:100%;-o-object-fit:contain;object-fit:contain;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
